const initialState = {
  vvds: [],
  // Full VVD list from /cargo/vvds/all (domestic; all directions).
  // Do not share with `vvds` (/cargo/vvds, international E/S only).
  vvdsAll: [],
  packageTypes: [],
  containerTypes: [],
  weighMethods: [],
  unitOfMeasures: [],
  serviceContracts: [],
  serviceTypes: [],
  portofLoad: [],
  portofLoading: [],
  gridPrefBR: null,
  gridPrefOCP: null,
  gridPrefSI: null,
  gridPrefSITemplates: null,
  gridPrefBLOI: null,
  gridPrefBLD: null,
  gridPrefSV: null,
  gridPrefVA: null,
  gridPrefCD: null,
  gridPrefBD: null,
  gridPrefIKEVB: null,
  gridPrefIKEUB: null,
  gridPrefIKECN: null,
  gridPrefIKEMT: null,
  gridPrefIKECB: null,
  gridPrefIKECV: null,
  gridPrefIKETD: null,
  gridPrefIKEBD: null,
  trackAutosStatuses: [],
};

export default function dropdownReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_DROPDOWN':
      return { ...state, ...action.payload };
    case 'RESET_DROPDOWN':
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
